import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Grid,
  CircularProgress,
  OutlinedInput,
  ListItemText,
} from "@mui/material";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import ListSubheader from '@mui/material/ListSubheader';

export const BusScheduleRouteForm = () => {
  const navigate = useNavigate();
  const { userId, role, oId,pId } = useAuth();

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;

  const [formData, setFormData] = useState({
    busNumberPlate: "",
    routeNumber: "",
    busPickupLocation: "",
    busDropLocation: "",
    route: "",
  });

  const [routesArray, setRoutesArray] = useState(['ROUTE-1']);
const [selectedRoute, setSelectedRoute] = useState("");
const [newRoute, setNewRoute] = useState("");


  const [newStop, setNewStop] = useState("");
  const [stopsArray, setStopsArray] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedStops, setSelectedStops] = useState([]);


  const [newTrip, setNewTrip] = useState("");
  const [tripsArray, setTripsArray] = useState(['TRIP-1']);
  const [selectedTrips, setSelectedTrips] = useState([]);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;


  

    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`
        );
        if (!response.ok) throw new Error("Failed to fetch users");
        const data = await response.json();
        setUsers(data);
        if (data.length > 0) setSelectedUsers(data[0].userId);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
 useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : `${name.replace(/([A-Z])/g, " $1")} is required`,
    }));
  };

const handleAddRoute = () => {
  const trimmedRoute = newRoute.trim();
  if (trimmedRoute && !routesArray.includes(trimmedRoute)) {
    setRoutesArray((prev) => [...prev, trimmedRoute]);
    setNewRoute("");
    setErrors((prevErrors) => ({ ...prevErrors, routeNumber: "" }));
  }
};

const handleRemoveRoute = (indexToRemove) => {
  setRoutesArray((prevRoutes) => {
    const routeToRemove = prevRoutes[indexToRemove];
    // Clear selection if the selected route is removed
    if (selectedRoute === routeToRemove) {
      setSelectedRoute("");
    }
    return prevRoutes.filter((_, index) => index !== indexToRemove);
  });
};





  const handleAddStop = () => {
    const trimmedStop = newStop.trim();
    if (trimmedStop) {
      setStopsArray((prev) => [...prev, trimmedStop]);
      setNewStop("");
      setErrors((prevErrors) => ({ ...prevErrors, stops: "" }));
    }
  };

  const handleRemoveStop = (indexToRemove) => {
  setStopsArray((prevStops) => {
    const stopToRemove = prevStops[indexToRemove];
    // Update selectedStops to remove this stop
    setSelectedStops((prevSelected) =>
      prevSelected.filter((selected) => selected !== stopToRemove)
    );
    // Remove stop from stopsArray
    return prevStops.filter((_, index) => index !== indexToRemove);
  });
};



  const handleAddTrip = () => {
    const trimmedTrips = newTrip.trim();
    if (trimmedTrips) {
      setTripsArray((prev) => [...prev, trimmedTrips]);
      setNewTrip("");
      setErrors((prevErrors) => ({ ...prevErrors, routes: "" }));
    }
  };

  // const handleRemoveTrip = (indexToRemove) => {
  //   setTripsArray((prev) => prev.filter((_, index) => index !== indexToRemove));
  // };
  const handleRemoveTrip = (indexToRemove) => {
  setTripsArray((prevTrips) => {
    const tripToRemove = prevTrips[indexToRemove];
    // Remove from selectedTrips too
    setSelectedTrips((prevSelected) =>
      prevSelected.filter((selected) => selected !== tripToRemove)
    );
    // Return updated tripsArray without the removed trip
    return prevTrips.filter((_, index) => index !== indexToRemove);
  });
};


  const validateForm = () => {
    const newErrors = {};

    if (!formData.busNumberPlate.trim())
      newErrors.busNumberPlate = "Bus Number is required";
    // if (!formData.routeNumber.trim())
    //   newErrors.routeNumber = "Route number is required";
    if (!selectedRoute || !selectedRoute.trim()) {
  newErrors.routeNumber = "Route number is required";
}

    if (!formData.busPickupLocation.trim())
      newErrors.busPickupLocation = "Pickup location is required";
    if (!formData.busDropLocation.trim())
      newErrors.busDropLocation = "Drop location is required";
    if (!formData.route.trim()) newErrors.route = "Route is required";
    if (stopsArray.length === 0) newErrors.stops = "Please add at least one stop";
    if (tripsArray.length === 0) newErrors.routes = "Please add at least one Trip";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.", { autoClose: 2000 });
      return;
    }

    try {
      setLoading(true);

      const formDataToSend = new URLSearchParams();
      formDataToSend.append("busNumberPlate", formData.busNumberPlate);
      formDataToSend.append("routeNumber",  selectedRoute);
      formDataToSend.append("busPickupLocation", formData.busPickupLocation);
      formDataToSend.append("busDropLocation", formData.busDropLocation);
      formDataToSend.append("route", formData.route);
      formDataToSend.append("stops", JSON.stringify(stopsArray)); // send as JSON array
      formDataToSend.append("routes", JSON.stringify(tripsArray)); // send as JSON array

      const UserId = userId || selectedUsers;

      const response = await fetch(
        `${baseUrl}/api/SchedulingRoute/save/${UserId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: formDataToSend.toString(),
        }
      );

      const responseText = await response.text();

      if (response.ok) {
        setLoading(false);
        await new Promise((resolve) => {
          toast.success(`Bus Route registration successful!`, {
            position: "top-right",
            autoClose: 1000,
            onClose: resolve,
          });
        });
        navigate(-1);
        setFormData({
          busNumberPlate: "",
          routeNumber: "",
          busPickupLocation: "",
          busDropLocation: "",
          route: "",
        });
        setStopsArray([]);
      } else {
        const errorMessage = responseText || "Failed to submit form.";
        toast.error(errorMessage, { position: "top-right", autoClose: 2500 });
      }
    } catch (error) {
      console.error("Submission Error:", error);
      toast.error(`Error submitting form: ${error.message}`, { autoClose: 2500 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
          Scheduling Bus Route Registration Form
        </Typography>
      </Box>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Bus Number"
              name="busNumberPlate"
              value={formData.busNumberPlate}
              onChange={handleInputChange}
              error={!!errors.busNumberPlate}
              helperText={errors.busNumberPlate}
            />
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Route Number"
              name="routeNumber"
              value={formData.routeNumber}
              onChange={handleInputChange}
              error={!!errors.routeNumber}
              helperText={errors.routeNumber}
            />
          </Grid> */}

          <Grid item xs={12} sm={6} md={4}>
  <FormControl fullWidth >
    <InputLabel>Select Route Number</InputLabel>
    <Select
      value={selectedRoute}
      onChange={(e) => setSelectedRoute(e.target.value)}
      input={<OutlinedInput label="Select Route Number" />}
      renderValue={(selected) => selected || ""}
      MenuProps={{ PaperProps: { style: { width: '160px' } } }}
      error={!!errors.routeNumber}
    >
      {/* Add Route Field using ListSubheader */}
      <ListSubheader
        disableSticky
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 1,
          py: 1,
          bgcolor: 'background.paper',
          '&:hover': { bgcolor: 'background.paper' }
        }}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <Box display="flex" gap={1} width="100%">
          <TextField
            placeholder="Add Route"
            size="small"
            value={newRoute}
            onChange={(e) => {
              e.stopPropagation();
              const rawValue = e.target.value.toUpperCase();
              const filteredValue = rawValue.replace(/[^A-Z0-9\-_ ]/g, "");
              setNewRoute(filteredValue);
            }}
            sx={{ width: '80%' }}
            fullWidth
            autoFocus
            error={!!errors.routeNumber}
            onKeyDown={(e) => {
              e.stopPropagation();
              if (e.key === "Enter") {
                e.preventDefault();
                handleAddRoute();
              }
            }}
          />
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleAddRoute();
            }}
            disabled={!newRoute.trim()}
          >
            <AddIcon />
          </IconButton>
        </Box>
      </ListSubheader>

      {/* Route Options */}
      {routesArray.map((route, index) => (
        <MenuItem key={index} value={route}>
          <ListItemText primary={route} />
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveRoute(index);
            }}
            sx={{ ml: 1 }}
          >
            <CloseIcon />
          </IconButton>
        </MenuItem>
      ))}
    </Select>

    {errors.routeNumber && (
      <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
        {errors.routeNumber}
      </Typography>
    )}
  </FormControl>
</Grid>


          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Bus Pickup Location"
              name="busPickupLocation"
              value={formData.busPickupLocation}
              onChange={handleInputChange}
              error={!!errors.busPickupLocation}
              helperText={errors.busPickupLocation}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Bus Drop Location"
              name="busDropLocation"
              value={formData.busDropLocation}
              onChange={handleInputChange}
              error={!!errors.busDropLocation}
              helperText={errors.busDropLocation}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Route Via"
              name="route"
              value={formData.route}
              onChange={handleInputChange}
              error={!!errors.route}
              helperText={errors.route}
            />
          </Grid>

          {/* Dynamic Stops Input */}
          <Grid item xs={12} sm={6} md={4}>
           <FormControl fullWidth >
  <InputLabel>Select Stops</InputLabel>
  <Select
    multiple
    // value={selectedStops}
    // onChange={(e) => setSelectedStops(e.target.value)}
    // renderValue={(selected) => selected.join(", ")}
    value={selectedStops}
onChange={(e) => {
  const value = e.target.value;
  setSelectedStops(Array.isArray(value) ? value : []);
}}
renderValue={(selected) => Array.isArray(selected) ? selected.join(", ") : ""}

    input={<OutlinedInput label="Select Stops" />}
    MenuProps={{ PaperProps: { style: { width: '160px' } } }}
    error={!!errors.stops}



  >
    {/* Add Stop Field using ListSubheader */}
    <ListSubheader
      disableSticky
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 1,
        py: 1,
        bgcolor: 'background.paper',
        '&:hover': { bgcolor: 'background.paper' }
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <Box display="flex" gap={1} width="100%">
 
        <TextField
  placeholder="Add Stops"
  size="small"
  value={newStop}
  onChange={(e) => {
    e.stopPropagation();
    // Convert input to uppercase and filter allowed characters
    const rawValue = e.target.value.toUpperCase();
    // const filteredValue = rawValue.replace(/[^A-Z0-9\-_]/g, "");
    const filteredValue = rawValue.replace(/[^\p{Script=Telugu}A-Z0-9\-_ ]/gu, "");

    setNewStop(filteredValue);
  }}
  sx={{ width: '80%' }}
  fullWidth
  autoFocus
  error={!!errors.stops}
  onKeyDown={(e) => {
    e.stopPropagation();
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddStop();
    }
  }}
/>

        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleAddStop();
          }}
         
          disabled={!newStop.trim()}
        >
          <AddIcon  />
        </IconButton>
      </Box>
    </ListSubheader>

    {/* Stop Options */}
    {stopsArray.map((stop, index) => (
      <MenuItem key={index} value={stop}>
        <Checkbox checked={selectedStops.indexOf(stop) > -1} />
        <ListItemText primary={stop} />
        <IconButton
        
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveStop(index);
          }}
          sx={{ ml: 1 }}
        >
          <CloseIcon  />
        </IconButton>
      </MenuItem>
    ))}
  </Select>

  {errors.stops && (
    <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
      {errors.stops}
    </Typography>
  )}
</FormControl>


          </Grid>

  {/* Dynamic Trips Input */}
          <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
  <InputLabel>Select Trips</InputLabel>
  <Select
    multiple
    // value={selectedTrips}
    // onChange={(e) => setSelectedTrips(e.target.value)}
    // renderValue={(selected) => selected.join(", ")}
    value={selectedTrips}
onChange={(e) => {
  const value = e.target.value;
  setSelectedTrips(Array.isArray(value) ? value : []);
}}
renderValue={(selected) => Array.isArray(selected) ? selected.join(", ") : ""}
    input={<OutlinedInput label="Select Trips" />}
    MenuProps={{ PaperProps: { style: { width: '160px' } } }}
    error={!!errors.routes}
  >
    {/* Add Trip Field using ListSubheader */}
    <ListSubheader
      disableSticky
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 1,
        py: 1,
        bgcolor: 'background.paper',
        '&:hover': { bgcolor: 'background.paper' }
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <Box display="flex" gap={1} width="100%">
        <TextField
  placeholder="Add Trips"
  size="small"
  value={newTrip}
  onChange={(e) => {
    e.stopPropagation();
    // Convert input to uppercase and filter allowed characters
    const rawValue = e.target.value.toUpperCase();
    const filteredValue = rawValue.replace(/[^A-Z0-9\-_ ]/g, "");  // space allowed here
    setNewTrip(filteredValue);
  }}
  sx={{ width: '80%' }}
  fullWidth
  autoFocus
  error={!!errors.routes}
  onKeyDown={(e) => {
    e.stopPropagation();
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddTrip();
    }
  }}
/>

        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleAddTrip();
          }}
          disabled={!newTrip?.trim()}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </ListSubheader>

    {/* Trip Options */}
    {tripsArray.map((trip, index) => (
      <MenuItem key={index} value={trip}>
        <Checkbox checked={selectedTrips.indexOf(trip) > -1} />
        <ListItemText primary={trip} />
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveTrip(index);
          }}
          sx={{ ml: 1 }}
        >
          <CloseIcon />
        </IconButton>
      </MenuItem>
    ))}
  </Select>

  {errors.routes && (
    <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
      {errors.routes}
    </Typography>
  )}
</FormControl>
</Grid>


          {/* Select User Dropdown */}
          {/* {isPrincipal && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small" sx={{ height: 50 }}>
                <InputLabel>Select User</InputLabel>
                <Select
                  value={selectedUsers}
                  onChange={(e) => setSelectedUsers(e.target.value)}
                  label="Select User"
                  sx={{
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {users.map((user) => (
                    <MenuItem key={user.userId} value={user.userId}>
                      {user.userId} - {user.firstName} {user.lastName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )} */}
        </Grid>

        <Grid container justifyContent="right" sx={{ marginTop: 4 }}>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              sx={{
                padding: "10px 20px",
                backgroundColor: "#3C3972 !important",
                fontWeight: "bold",
                minWidth: "150px",
                "&:hover": { backgroundColor: "#3C3972 !important" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Register Bus"}
            </Button>
          </Grid>
        </Grid>
      </form>

      <ToastContainer />
    </Box>
  );
};